import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "SCM Foundations & Global Business Ecosystem",
    description:
      "Introduction to Supply Chain Management ,Scope & importance, Components of a supply chain: suppliers → manufacturers → distributors → customers, Supply chain flows: information materials & finances, Role of SCM in modern businesses & e-commerce, Global supply chain challenges & opportunities",
  },
  {
    title: "Procurement, Sourcing & Supplier Relationship Management",
    description:
      "Supplier selection and evaluation, Negotiation strategies & contract management, Make vs buy decision-making, Vendor development & long-term partnerships, Risk management in sourcing & procurement",
  },
  {
    title: "Logistics, Transportation & Distribution Networks",
    description:
      "Modes of transportation: road rail air sea, Fleet management & route optimization, Distribution center design & functions, Last-mile delivery challenges, International logistics & INCOTERMS",
  },
  {
    title: "Inventory Management & Warehouse Operations",
    description:
      "Types of inventory & inventory control techniques, EOQ safety stock reorder levels, Warehouse layout storage systems & automation, Picking packing & dispatch processes, Reducing inventory costs while maximizing availability",
  },
  {
    title: "Production Planning, Scheduling & Operations Management",
    description:
      "Demand forecasting and planning, MRP (Material Requirements Planning) & CRP, Lean manufacturing principles, Capacity planning & workflow optimization, Reducing bottlenecks in production lines",
  },
  {
    title: "Supply Chain Analytics & Data-Driven Decision Making",
    description:
      "Using data to optimize supply chain performance, KPIs: OTIF fill rate lead time cycle time, Forecasting models & demand sensing, Tools: Excel Power BI Tableau basics, Data visualization for operational decisions",
  },
  {
    title: "Quality Control, Compliance & Risk Management",
    description:
      "Quality standards in supply chain: ISO Six Sigma, Supplier audits & compliance checks, Identifying supply chain risks: operational financial geopolitical, Mitigation strategies & contingency planning, Ensuring product consistency & customer satisfaction",
  },
  {
    title: "Sustainability, Green Supply Chains & Ethical Operations",
    description:
      "Eco-friendly materials & responsible sourcing, Carbon footprint measurement in supply chains, Reverse logistics & recycling systems, Circular supply chain models, Ethical and socially responsible supply chain practices",
  },
  {
    title: "ERP, Automation & Digital Transformation in SCM",
    description:
      "ERP systems (SAP Oracle) fundamentals, Automation & robotics in warehousing, IoT RFID & barcode tracking, Blockchain for supply chain transparency, AI/ML in forecasting & optimization.",
  },
  {
    title: "Capstone SCM Project & Career Launchpad",
    description:
      "End-to-end supply chain case study, Designing a complete supply chain model, KPI-based performance evaluation, Portfolio creation for SCM roles, Interview prep for Supply Chain Analyst Operations Manager Logistics Coordinator Procurement Specialist",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
